export default {
    permisos: '',
    permiso: '',
    error: false,
    errorMessage: '',
    isOk: false,
    

  }